import { PageId } from 'constants/pages'

export const enum PageIdWoofzWS2 {
  AGE_WS2 = PageId.AGE_WS2,
  SEX_WS2 = PageId.SEX_WS2,
  URGE_WS2 = PageId.URGE_WS2,
  BREED_WS2 = PageId.BREED_WS2,
  URGE_WS2_2 = PageId.URGE_WS2_2,
  WORRIES_WS2 = PageId.WORRIES_WS2,
  URGE_WS2_3 = PageId.URGE_WS2_3,
  LICK_PAWS_WS2 = PageId.LICK_PAWS_WS2,
  DRAG_BOTTOM_WS2 = PageId.DRAG_BOTTOM_WS2,
  CHECK_EARS_WS2 = PageId.CHECK_EARS_WS2,
  WASH_TEETH_WS2 = PageId.WASH_TEETH_WS2,
  CLEAN_EYES_WS2 = PageId.CLEAN_EYES_WS2,
  BREATH_WS2 = PageId.BREATH_WS2,
  WEIGHT_WS2 = PageId.WEIGHT_WS2,
  FEED_WS2 = PageId.FEED_WS2,
  FOOD_PORTIONS_WS2 = PageId.FOOD_PORTIONS_WS2,
  URGE_WS2_4 = PageId.URGE_WS2_4,
  WATER_WS2 = PageId.WATER_WS2,
  CLEAN_BOWLS_WS2 = PageId.CLEAN_BOWLS_WS2,
  COAT_WS2 = PageId.COAT_WS2,
  WALK_WS2 = PageId.WALK_WS2,
  URGE_WS2_5 = PageId.URGE_WS2_5,
  VET_WS2 = PageId.VET_WS2,
  PROTECT_WS2 = PageId.PROTECT_WS2,
  CHRONIC_WS2 = PageId.CHRONIC_WS2,
  BEHAVIOR_CHANGES_WS2 = PageId.BEHAVIOR_CHANGES_WS2,
  URGE_WS2_6 = PageId.URGE_WS2_6,
  ITCH_WS2 = PageId.ITCH_WS2,
  ALONE_WS2 = PageId.ALONE_WS2,
  URGE_WS2_7 = PageId.URGE_WS2_7,
  SLEEP_WS2 = PageId.SLEEP_WS2,
  SLEEPING_ENV_WS2 = PageId.SLEEPING_ENV_WS2,
  URGE_WS2_8 = PageId.URGE_WS2_8,
  DOG_NAME_WS2 = PageId.DOG_NAME_WS2,
  SPEND_TIME_WS2 = PageId.SPEND_TIME_WS2,
  PREPARE_FLOW_WS2 = PageId.PREPARE_FLOW_WS2,
  EMAIL_WS2 = PageId.EMAIL_WS2,
  NEWSLETTER_URGE_WS2 = PageId.NEWSLETTER_URGE_WS2,
  URGE_WS2_9 = PageId.URGE_WS2_9,
  GIFT_WS2 = PageId.GIFT_WS2,
  WELCOME_WS2 = PageId.WELCOME_WS2,
  SUBSCRIPTIONS_WS2 = PageId.SUBSCRIPTIONS_WS2,
  CANCEL_OFFER_WS2 = PageId.CANCEL_OFFER_WS2,
  CHAT_UPSELL_WS2 = PageId.CHAT_UPSELL_WS2,
  UPSELL_WS2 = PageId.UPSELL_WS2,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_WS2 = PageId.DOWNLOAD_WS2,
  // invoxia
  // INVOXIA_CONGRATULATIONS = PageId.INVOXIA_CONGRATULATIONS,
  // INVOXIA_REVIEW = PageId.INVOXIA_REVIEW,
  // INVOXIA_DETAILS = PageId.INVOXIA_DETAILS,
}
